import React, { useEffect, useState } from 'react'
import {
	Blacked,
	ModalContent,
	ModalHeader,
	ModalInput,
	ModalSubmit,
	ModalTitle,
	ModalWrapper,
} from '../styles'
import { Icon } from 'CRM/organism/Main/styles'
import { FaChevronLeft } from 'react-icons/fa6'
import { Input, Select, Upload, message } from 'antd'
import { ChromePicker } from 'react-color'
import API from 'utils/api'
import { useToken } from 'app/hooks'
import { usePathList } from 'CRM/hooks/GetPathList'
import TextArea from 'antd/es/input/TextArea'
import { useCategoryList } from 'CRM/hooks/GetCategory'
import { usePlatformList } from 'CRM/hooks/GetPlatformList'
import {useIsMobile} from "../IsMobile";

export const WorkAdd = ({ setIsRequest, mutate }) => {
	const IsMobile = useIsMobile();
	const { data: token } = useToken()
	const { categoryList } = useCategoryList()
	const { platformList } = usePlatformList()
	const [platform, setPlatform] = useState(platformList?.[0]?.id)
	const [email, setEmail] = useState('')
	const [category, setCategory] = useState(categoryList?.[0]?.id)
	const [template, setTemplate] = useState('')

	const [images, setImages] = useState<any>([])

	useEffect(() => {
		setTemplate(categoryList?.find(it => it.id == category)?.template)
	}, [category])

	const clickSubmit = () => {
		const shouldEdit = window.confirm(
			` 등록하실 내용이 맞습니까? \n 플랫폼: ${platform} \n 이메일: ${email} \n 내용: ${template}`
		)
		if (shouldEdit) {
			const targetFilesArrayLogo = Array.from(images?.fileList || [])
			const formData = new FormData()

			if (images?.fileList?.length == 0) {
				message.error('파일을 선택해주세요')
				return
			}

			targetFilesArrayLogo.forEach((file: any) => {
				if (file.originFileObj) {
					formData.append('files', file.originFileObj)
				}
			})

			formData.append(
				'datas',
				JSON.stringify({
					content: template,
					categoryId: category,
					platformId: platform,
					email: email,
				})
			)

			if (template == '') {
				message.error('내용을 입력해주세요.')
			}

			API.postImage('POST', '/board/request', token + '', formData)
				.then((res: any) => {
					if (res.result.success) {
						message.success('등록되었습니다')
						mutate()
						setIsRequest(false)
					} else {
						message.error('파일이 잘못되었습니다')
					}
				})
				.catch((err: any) => {})
		}
	}

	return (
		<>
			<Blacked onClick={() => setIsRequest(false)} />
			<ModalWrapper IsMobile={IsMobile}>
				<ModalHeader>
					<Icon onClick={() => setIsRequest(false)}>
						<FaChevronLeft />
					</Icon>
					<ModalTitle>업무 요청</ModalTitle>
					<ModalSubmit onClick={clickSubmit}>등록</ModalSubmit>
				</ModalHeader>
				<ModalContent>
					<ModalInput>
						<label htmlFor="name">플랫폼</label>
						<Select
							value={platform}
							onChange={e => setPlatform(e)}
							placeholder="플랫폼 선택"
							style={{ fontFamily: 'Pretendard' }}>
							{platformList?.map(it => (
								<option value={it.id} style={{ fontFamily: 'Pretendard' }}>
									{it.name}
								</option>
							))}
						</Select>
					</ModalInput>
					<ModalInput>
						<label htmlFor="name">이메일</label>
						<Input
							value={email}
							onChange={e => setEmail(e.target.value)}
							placeholder="이메일 입력"
						/>
					</ModalInput>
					<ModalInput>
						<label htmlFor="name">카테고리</label>
						<Select
							value={category}
							onChange={e => setCategory(e)}
							placeholder="카테고리 선택"
							style={{ fontFamily: 'Pretendard' }}>
							{categoryList?.map(it => (
								<option value={it.id} style={{ fontFamily: 'Pretendard' }}>
									{it.name}
								</option>
							))}
						</Select>
					</ModalInput>
					<ModalInput>
						<label htmlFor="desc">내용입력</label>
						<TextArea
							value={template}
							onChange={e => setTemplate(e.target.value)}
							placeholder="카테고리 선택 후 작성"
							style={{ width: '100%', height: 200, resize: 'none', fontFamily: 'Pretendard' }}
						/>
					</ModalInput>

					<ModalInput>
						<label htmlFor="desc">이미지 업로드</label>

						<Upload
							onChange={(fileList: any) => {
								setImages(fileList)
							}}>
							파일선택
						</Upload>
					</ModalInput>
				</ModalContent>
			</ModalWrapper>
		</>
	)
}

export default React.memo(WorkAdd)
